import { render, staticRenderFns } from "./SoCourseHistory.vue?vue&type=template&id=9135f36a&"
import script from "./SoCourseHistory.vue?vue&type=script&lang=js&"
export * from "./SoCourseHistory.vue?vue&type=script&lang=js&"
import style0 from "./SoCourseHistory.vue?vue&type=style&index=0&id=9135f36a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports